module.exports = __webpack_public_path__ + "static/media/Preview-MapTilerPositron.a6fad8aa.png";